<template>
  <div class="main-container">
    <!-- breadcrumb -->
    <breadcrumb
      main_step_name="Organisation"
      sub_step_name="Utilities"
      @goToMainStep="routeToMainStep"
    />
    <!-- <ul class="breadcrumb">
      <li>
        <a href="#">Organisation</a>
      </li>
      <li>Utilities</li>
    </ul>-->
    <!-- breadcrumb -->

    <section class="main-content-section">
      <tl-header type="h1">Example Title One</tl-header>
      <div class="threeColumnGrid marginbottom-5p">
        <div class="example-list">
          <div class="d-heading2">Example Subtitle One</div>
          <ul class="example-item">
            <li>
              <a
                href="javascript:void(0)"
                v-on:click="goToDownloadUpload"
              >Download/Upload Master Template</a>
            </li>
            <li>
              <a href="javascript:void(0)">Change Employee Code</a>
            </li>
            <li>
              <a href="javascript:void(0)">Voluntary PF</a>
            </li>
            <li>
              <a href="javascript:void(0)" v-on:click="goToFBPSettings">FBP Settings</a>
            </li>
            <li>
              <a href="javascript:void(0)" disabled>Employee Master Fields</a>
            </li>
            <li>
              <a href="javascript:void(0)" disabled>Mobile/Telephone Bill Claim</a>
            </li>
          </ul>
        </div>
        <div class="example-list">
          <div class="d-heading2">Example Subtitle Two</div>
          <ul class="example-item">
            <li>
              <a href="javascript:void(0)" disabled>Employee Bank Info</a>
            </li>
            <li>
              <a href="javascript:void(0)" disabled>Employee PAN Info</a>
            </li>
            <li>
              <a href="javascript:void(0)" disabled>Payroll Status</a>
            </li>
          </ul>
        </div>
        <div class="example-list">
          <div class="d-heading2">Example Subtitle Three</div>
          <ul class="example-item">
            <li>
              <a href="javascript:void(0)" disabled>Import Financial Information</a>
            </li>
            <li>
              <a href="javascript:void(0)" disabled>Import Investment Declaration</a>
            </li>
            <li>
              <a href="javascript:void(0)" disabled>Import Bonuses with Payout Date</a>
            </li>
            <li>
              <a href="javascript:void(0)" disabled>Import Salaries with Effective Date</a>
            </li>
          </ul>
        </div>
        <div class="example-list">
          <div class="d-heading2">Example Subtitle Three</div>
          <ul class="example-item">
            <li>
              <a href="javascript:void(0)" disabled>Legacy Salary Data</a>
            </li>
            <li>
              <a href="javascript:void(0)" disabled>Previous PF Import</a>
            </li>
            <li>
              <a href="javascript:void(0)" disabled>Legacy Attendance Import</a>
            </li>
            <li>
              <a href="javascript:void(0)" disabled>CompOff Import</a>
            </li>
            <li>
              <a href="javascript:void(0)" disabled>Leave OB Import</a>
            </li>
            <li>
              <a href="javascript:void(0)" disabled>Processed Pay</a>
            </li>
            <li>
              <a href="javascript:void(0)" disabled>Update Employee Restrict Holidays</a>
            </li>
            <li>
              <a href="javascript:void(0)" disabled>Leave Request Import</a>
            </li>
          </ul>
        </div>
      </div>

      <tl-header type="h1">Example Title Two</tl-header>
      <div class="threeColumnGrid marginbottom-5p">
        <ul class="example-item">
          <li>
            <a href="javascript:void(0)" disabled>Employee PF and ESI Info</a>
          </li>
          <li>
            <a
              href="javascript:void(0)"
              disabled
            >PF Overrides (Define employer &amp; employee share, including VPF)</a>
          </li>
          <li>
            <a href="javascript:void(0)" disabled>ESI deductions Overrides</a>
          </li>
        </ul>
        <ul class="example-item">
          <li>
            <a href="javascript:void(0)" disabled>Employee PF and ESI Info</a>
          </li>
          <li>
            <a
              href="javascript:void(0)"
              disabled
            >PF Overrides (Define employer &amp; employee share, including VPF)</a>
          </li>
          <li>
            <a href="javascript:void(0)" disabled>ESI deductions Overrides</a>
          </li>
        </ul>
      </div>
      <tl-header type="h1">Example Title Three</tl-header>
      <div class="threeColumnGrid marginbottom-5p">
        <ul class="example-item">
          <li>
            <a href="javascript:void(0)" disabled>PT Deduction Overrides</a>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    goToDownloadUpload() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/downloaduploadmastertemplate`
      });
    },
    routeToMainStep() {},
    goToFBPSettings() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/fbpsettingsandcomponentmapping`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.d-heading2 {
  padding-bottom: 7px;
  margin-bottom: 7px;
  border-bottom: solid 2px #eaeaea;
}
li {
  font-size: 14px;
  margin-left: 30px;
  a {
    text-decoration: none;
    color: inherit;
  }
}
.example-item {
  li::before {
    content: "\2022";
    color: #d8d8d8;
    font-size: 26px;
    font-weight: bold;
    display: inline-block;
    width: 24px;
    top: 3px;
    position: relative;
    margin-left: -15px;
  }
}
</style>
